import jsCookie from 'js-cookie'

import {parseCountry} from '../countries'

/*
 * Simulating another visitor, from the debug modal - see "Debugging" in docs/visitor-preferences.md.
 * A layer in front of the resolver: it replaces facts about the visitor where they are read, so
 * everything derived from them follows as it would for a real visitor, and nothing is stored.
 */

export const debugPreferencesCookieName = 'debug-preferences'

export type DebugOverrides = {
  country?: string
  // Its TLD decides the region and the domain, e.g. https://tramatm.sk
  host?: string
}

export const getDebugOverrides = (cookieValue: string | undefined): DebugOverrides => {
  if (!cookieValue) {
    return {}
  }
  try {
    const overrides: unknown = JSON.parse(cookieValue)
    if (typeof overrides !== 'object' || overrides === null) {
      return {}
    }
    const {country, host: hostOverride} = overrides as Record<string, unknown>
    return {
      country: typeof country === 'string' ? parseCountry(country) : undefined,
      host: typeof hostOverride === 'string' ? hostOverride : undefined,
    }
  } catch {
    return {}
  }
}

// In the browser - only from an effect or an event handler
export const readDebugOverrides = () => getDebugOverrides(jsCookie.get(debugPreferencesCookieName))

// The debug modal's writer; the page reloads after it, so a server render sees the same visitor
export const writeDebugOverrides = (overrides: DebugOverrides) => {
  if (!overrides.country && !overrides.host) {
    jsCookie.remove(debugPreferencesCookieName)
    return
  }
  jsCookie.set(debugPreferencesCookieName, JSON.stringify(overrides), {sameSite: 'lax'})
}
